<template>
  <div>
    <Navbar />
    <MainBanner />
    <HowCanHelp />
    <Screenshots />
    <SoftwareIntegrations />
    <Funfacts />
    <AppDownload />
    <Footer />
  </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import MainBanner from '../hawk-crm/MainBanner'
import HowCanHelp from '../hawk-crm/HowCanHelp'
import Screenshots from '../hawk-crm/Screenshots'
import SoftwareIntegrations from '../hawk-crm/SoftwareIntegrations'
import Funfacts from '../hawk-crm/Funfacts'
import AppDownload from '../hawk-crm/AppDownload'
import Footer from '../Layouts/Footer'

export default {
  name: 'SoftwarePage',
  components: {
    Navbar,
    MainBanner,
    HowCanHelp,
    Screenshots,
    SoftwareIntegrations,
    Funfacts,
    AppDownload,
    Footer,
  }
}
</script>